import { ArrowRight } from "lucide-react";
import { CHECKOUT_URL } from "@/lib/constants";

export default function StickyMobileCTA() {
    return (
        <div
            data-testid="cta-sticky-mobile"
            className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-cream shadow-[0_-8px_24px_-12px_rgba(11,59,36,0.18)]"
        >
            <div className="flex items-center justify-between gap-3 px-4 py-3">
                <div className="leading-tight">
                    <p className="text-[10px] uppercase tracking-[0.18em] text-emerald-light/70 font-bold">
                        Hoje por
                    </p>
                    <p className="font-serif text-emerald-brand text-2xl leading-none">
                        R$ 47{" "}
                        <span className="text-xs text-emerald-light/60 line-through ml-1">
                            R$ 97
                        </span>
                    </p>
                </div>
                <a
                    href={CHECKOUT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="cta-sticky-mobile-btn"
                    className="btn-gold py-3 px-5 text-sm"
                >
                    Destravar
                    <ArrowRight className="w-4 h-4" />
                </a>
            </div>
        </div>
    );
}
